import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

type PlateCodeLookup = {
  Id?: string;
  Code?: string;
  Title?: string;
};

export function isPublicUsageType(...usageTypes: Array<string | undefined>) {
  return usageTypes.some(
    (usageType) => (usageType || '').trim().toLowerCase() === 'public'
  );
}

function isPlateCodeP(plateCode?: PlateCodeLookup | null) {
  return [plateCode?.Code, plateCode?.Id, plateCode?.Title].some(
    (value) => (value || '').trim().toUpperCase() === 'P'
  );
}

export function filterPlateCodeLookups(
  plateCodes: PlateCodeLookup[] = [],
  usageType = ''
) {
  const visiblePlateCodes = plateCodes ?? [];
  if (isPublicUsageType(usageType)) {
    return visiblePlateCodes;
  }

  // Code P is shown only when Usage Type is Public.
  return visiblePlateCodes.filter((plateCode) => !isPlateCodeP(plateCode));
}

export function toLookups(data: any, usageType = '') {
  const policyDetailsList: Record<string, Record<string, string>> = {};
  policyDetailsList['phoneType'] = enumListAsRecordObject(
    data?.Insurance_PhoneType?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );
  policyDetailsList['renewalStatus'] = enumListAsRecordObject(
    data?.Insurance_RenewalStatus?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );
  policyDetailsList['countries'] = lookupListAsRecordObject(
    data?.Insurance?.lookups?.countries
  );
  policyDetailsList['brands'] = lookupListAsRecordObject(
    data?.Insurance?.lookups?.brands
  );
  policyDetailsList['plateCode'] = lookupListAsRecordObject(
    filterPlateCodeLookups(data?.Insurance?.lookups?.plateCodes, usageType)
  );
  policyDetailsList['engineTypes'] = lookupListAsRecordObject(
    data?.Insurance?.lookups?.engineTypes
  );

  return policyDetailsList;
}
